(function($) {

    'use strict';

    const Locations = function() {

        let config = {
            globalActiveClass: 'filter-is-open',
            panelToggleClass: 'panel-is-open',
            resultsToggleClass: 'location-results--active',
            tabPanelActive: 'active',
            $html: $('html'),
            $body: $('body'),
            $header: $('.header'),
            $locationWrapper: $('.location__wrapper'),
            $results: $('.location-results'),
            $filterButton: $('[data-js-filter]'),
            $closeButton: $('[data-js-filter-close]'),
            $resultsButton: $('[data-js-results-close]'),
            $backButton: $('[data-js-filter-back]'),
            $panels: '',
        };

        const init = function() {
            _events();
        };

        const _events = function() {
            config.$filterButton.on('click', _controlPanel);
            config.$filterButton.on('keyboard-focus', _controlPanel); 
            config.$closeButton.on('click', _deactivatePanels); 
            config.$backButton.on('click', _deactivateSecondaryPanel); 
            config.$resultsButton.on('click', _controlResults); 
        };

        /**
         * Check if panel is open
         * Returns jQuery Object
         */
        const _getPanelFromButton = function(button) {
            return $('#' + $(button).attr('aria-controls'));
        };

        /**
         * Check if panel is open
         */
        const _panelIsOpen = function(el) {
            return $(el).hasClass(config.panelToggleClass);
        };

        /**
         * Control focus when button clicked or keyboard focused 
         */
        const _controlPanel = function(e) {
            let el = _getPanelFromButton(e.target);

            setTimeout( function() {
                if(_panelIsOpen(el)){
                    _deactivatePanels();
                } else {
                    _openPanel(e.target, el, false);
                }
            }, 100);
           
        };

        /**
         * Control results panel on mobile (defaults to hidden)
         */
        const _controlResults = function(e) {
    
            setTimeout( function() {
                config.$results.toggleClass(config.resultsToggleClass);
            }, 100);
           
        };

        /**
         * Toggle panel class
         */
        const _openPanel = function(button, panel, setFocus = true) {
          
            setFocus = setFocus;

            // Deactivate all other panels
            _deactivatePanels();

            // Set the button as selected
            button.setAttribute('aria-selected', 'true');
   
            // Set the button as selected
            button.setAttribute('aria-expanded', 'true');

            // Add active class 
            panel.addClass(config.panelToggleClass);

            // Remove hidden attribute from tab panel to make it visible
            panel.removeAttr('hidden');

            // Set global class on html element
            config.$html.addClass(config.globalActiveClass);

            _setView();

            // Set focus when required
            if (setFocus) {    
                panel.focus();
            };
        };

        /**
         * Deactivate all tabs and tab panels
         */
        function _deactivatePanels () {
            config.$html.removeClass(config.globalActiveClass);

            for (let t = 0; t < config.$filterButton.length; t++) {
                
                let panel = _getPanelFromButton(config.$filterButton[t]);

                config.$filterButton[t].setAttribute('aria-selected', 'false');
                config.$filterButton[t].setAttribute('aria-expanded', 'false');
                panel.removeClass(config.panelToggleClass);
                panel.attr('tabindex', -1);
            };
        };
        
        /**
         * Deactivate secondary panels
         */
        function _deactivateSecondaryPanel (e) {
            var panel = $(e.target).closest('[role=tabpanel]');
            var tab = $('#' + panel.attr('aria-labelledby'));
            
            tab.attr('tabindex', '0');
            tab.attr('aria-selected', 'false');
            // tab.removeEventListener('focus', focusEventHandler);
            tab.removeClass(config.tabPanelActive);
            panel.attr('hidden', 'hidden');

        };

        /**
         * Set view to map and header
         */
        function _setView () {
            var headerHeight = 0;
            if(Modernizr.mq('only screen and (min-width: 768px)')) {
                var headerHeight = config.$header.height();
            }

            $.scrollTo(config.$locationWrapper.offset().top - headerHeight, 200);
        };



        return {
            init: init
        }

    }();

    module.exports = Locations;

})(jQuery);